export default {
    install: (app, options) => {
        app.prototype.tourLevelFormatter = function(level) {
            const LEVEL_MAP = {
                'Premier': 'WTA 500',
                'Premier5': 'WTA 1000 (P5)',
                'PremierMandatory': 'WTA 1000 (PM)',
                'International': 'WTA 250',
                'Challenger': 'WTA 125k',
                'Grand Slam': 'Grand Slam'
            }
            let formatted = LEVEL_MAP[level];
            return formatted !== undefined ? formatted : level;
        }
    }
}



// WEBPACK FOOTER //
// ./src/plugins/tournament-level.js